import React, { useContext, useEffect } from "react";
import { toast } from "react-toastify";
import authService from "../services/authService";
import userService from "../services/userService";
import { GlobalContext } from "../utility/GlobalContext";
import BusinessDashboard from "./Business/BusinessDashboard";
import CreatorDashboard from "./Creator/CreatorDashboard";

export default function Dashboard(props) {
  const { state, setState } = useContext(GlobalContext);

  useEffect(() => {
    // fetch user
    fetchUser();
    console.log("HERE: ", state);
  }, [state.jwt]);


  const fetchUser = () => {
    userService
      .fetchSelf(state.jwt)
      .then((response) => {
        setState({ ...state, user: response.data });
      })
      .catch((err) => {
        // toast.error(err.response.data.msg || "Error occurred")
      });
  };

  return (
    <div>
      <div>
        {state.user.type === "creator" && (
          <CreatorDashboard jwt={state.jwt} user={state.user} />
        )}
      </div>
      <div>
        {state.user.type === "business" && (
          <BusinessDashboard fetchUser={fetchUser} jwt={state.jwt} user={state.user} />
        )}
      </div>
    </div>
  );
}
